module.exports = __webpack_public_path__ + "img/image15.ce480358.png";